import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController } from 'ionic-angular';
import { ClubProvider } from '../../providers/club/club';
import { ClubEditFormComponent } from './club-edit-form/club-edit-form';


@Component({
  selector: 'club-popover',
  templateUrl: 'club-popover.html'
})
export class ClubPopoverComponent {

  clubId:string = '';
  userId:string = '';
  isUserOwner:boolean = false;
  constructor(public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public clubProvider: ClubProvider) {
      this.clubId = this.navParams.get('clubId');
      this.userId = this.navParams.get('userId');
      this.isUserOwner = this.navParams.get('isUserOwner');

  }

  ngOnInit(){
    console.log(this.clubId)
  }

  leaveClub(){
    this.clubProvider.leave(this.clubId, this.userId).subscribe((res) => {
      if(res.success){
        this.viewCtrl.dismiss();
      }
    })
  }

  editClub(clubId){

    let modalView = this.modalCtrl.create(ClubEditFormComponent, {clubId: clubId}, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.viewCtrl.dismiss();
    })
    modalView.present().then(() => {

    });
  }



}



// WEBPACK FOOTER //
// ./src/components/club-popover/club-popover.ts